module.exports = __webpack_public_path__ + "img/xq-bg.79f1ce52.jpg";